import { useQuery } from '@tanstack/react-query'
import { BetAccountHolder } from '@mobi/api-types'
import { queryKeys } from '../Utils'
import { accountUrl, get } from '../Utils/network'

export interface AccountHolders {
  primaryAccountHolder: BetAccountHolder
  secondaryAccountHolder: BetAccountHolder | null
}

type UseAccountHoldersProps = {
  enabled?: boolean
}

export function useAccountHolders(options: UseAccountHoldersProps) {
  return useQuery({
    queryKey: [queryKeys.accountHolders],
    queryFn: fetchAccountHolders,
    enabled: options.enabled,
    refetchOnWindowFocus: false,
    staleTime: 1000,
  })
}

export async function fetchAccountHolders(): Promise<AccountHolders> {
  return await get<AccountHolders>(accountUrl.getAccountHolders)
}
